import { useState } from 'react';
import type { PlatformCompany } from '../../../../types';

interface PriceBlockProps {
  show: boolean;
  company: Pick<PlatformCompany, 'productList' | 'onTimeDelivery' | 'replyAvgTime'>;
  showPriceSection: boolean;
  showStatsSection: boolean;
}

export function PriceBlock({ show, company, showPriceSection, showStatsSection }: PriceBlockProps) {
  const [imgError, setImgError] = useState(false);
  const product = company.productList?.[0];
  const priceText = product?.price || null;
  const moqText = product?.moq || null;
  const productImg = product?.image || null;
  const onTime = company.onTimeDelivery;
  const resp = company.replyAvgTime;

  if (!show) return null;

  return (
    <div className="h-[56px] mt-4 mb-5 flex flex-row items-center gap-2">
      {/* 商品图 */}
      {productImg && !imgError ? (
        <img
          src={productImg}
          alt="product"
          className="w-14 h-14 rounded object-cover bg-[#F5F5F5] shrink-0"
          onError={() => setImgError(true)}
        />
      ) : (
        <div className="w-14 h-14 rounded bg-[#F5F5F5] shrink-0" />
      )}

      {/* 价格 + MOQ */}
      {showPriceSection && (
        <div className="flex flex-col gap-1 min-w-0 flex-1">
          <span className="text-sm font-medium text-[#262626] truncate">{priceText ?? '—'}</span>
          <span className="text-sm text-[#8C8C8C] truncate">{moqText ? `Min. order: ${moqText}` : '—'}</span>
        </div>
      )}

      {/* 竖向分隔线 */}
      {showPriceSection && showStatsSection && <div className="self-stretch border-l border-[#E5E5E5] mx-1 shrink-0" />}

      {/* 统计数据：On-time + Resp */}
      {showStatsSection && (
        <div className="flex flex-col gap-1 shrink-0">
          <div className="flex flex-row items-center gap-1.5">
            <span className="text-sm text-[#8C8C8C]">On-time:</span>
            <span className="text-sm font-medium text-[#262626]">{onTime ?? '—'}</span>
          </div>
          <div className="flex flex-row items-center gap-1.5">
            <span className="text-sm text-[#8C8C8C]">Resp:</span>
            <span className="text-sm font-medium text-[#262626]">{resp ?? '—'}</span>
          </div>
        </div>
      )}
    </div>
  );
}
